/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awake_These_Slug_SkipInputs */

const fr_awake_these_slug_skip = /** @type {(inputs: Awake_These_Slug_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prog Hebdos`)
};

/**

* @param {Awake_These_Slug_SkipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awake_these_slug_skip = /** @type {((inputs?: Awake_These_Slug_SkipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awake_These_Slug_SkipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awake_these_slug_skip(inputs)
});